import { render } from "./adminPage.vue?vue&type=template&id=38d96538&scoped=true"
import script from "./adminPage.vue?vue&type=script&lang=js"
export * from "./adminPage.vue?vue&type=script&lang=js"

import "./adminPage.vue?vue&type=style&index=0&id=38d96538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d96538"]])

export default __exports__